module.exports = __webpack_public_path__ + "static/img/Charlize-Rule.7577cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlize-Rule.jpg
// module id = +HNH
// module chunks = 0